var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10.5,
    height: 15,
    viewBox: "0 0 10.5 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2981",
    "data-name": "Rectangle 2981",
    width: 10.5,
    height: 15,
    fill: "#e7f0f4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10632",
    "data-name": "Group 10632",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28432",
    "data-name": "Path 28432",
    d: "M5.781,10.719l-.109-.09a.633.633,0,0,0-.137-.07L5.4,10.5a.739.739,0,0,0-.679.2.9.9,0,0,0-.16.246.752.752,0,0,0,.976.985,1.061,1.061,0,0,0,.246-.168.744.744,0,0,0,.16-.817.767.767,0,0,0-.16-.23M8.25,0h-6A2.251,2.251,0,0,0,0,2.25v10.5A2.251,2.251,0,0,0,2.25,15h6a2.251,2.251,0,0,0,2.25-2.25V2.25A2.251,2.251,0,0,0,8.25,0M9,12.75a.75.75,0,0,1-.75.75h-6a.75.75,0,0,1-.75-.75V2.25a.75.75,0,0,1,.75-.75h6A.75.75,0,0,1,9,2.25Z",
    fill: "#e7f0f4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.ab15f992763d7fa532c247d27022b19c.svg";
export { ForwardRef as ReactComponent };